import Redirect from "../../components/Redirect";

export default function Incription() {
  return <Redirect to="/register?language=fr" />;
}
